import { WarrantyType } from "@dune/types";
import { useState } from "react";
import { useCreateOrUpdatePricingFile } from "../mutations/pricing-files.mutations";
import { getSignedPutUrl, uploadFileToS3 } from "../queries/files.queries";

export const usePricingFileUpload = () => {
	const [isUploading, setIsUploading] = useState(false);
	const [uploadError, setUploadError] = useState<string | null>(null);

	const createOrUpdatePricingFileMutation = useCreateOrUpdatePricingFile();

	const uploadPricingFile = async (
		file: File,
		warrantyType: WarrantyType,
		binderAmendmentId: number,
	) => {
		setIsUploading(true);
		setUploadError(null);

		try {
			const fileName = file.name.toLowerCase();
			const isValidExtension =
				fileName.endsWith(".xlsx") || fileName.endsWith(".xls");

			if (!isValidExtension) {
				throw new Error("Le fichier doit être au format Excel (.xlsx ou .xls)");
			}

			const contentType =
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
			const signedUrlData = await getSignedPutUrl({
				bucket: "private",
				contentType,
			});

			await uploadFileToS3(signedUrlData.signedUrl, file);

			await createOrUpdatePricingFileMutation.mutateAsync({
				bucket: "private",
				key: signedUrlData.key,
				name: file.name,
				mimeType: contentType,
				size: file.size,
				warrantyType,
				binderAmendmentId,
			});

			setIsUploading(false);
			return { success: true, key: signedUrlData.key };
		} catch (error) {
			setIsUploading(false);
			const errorMessage =
				error instanceof Error
					? error.message
					: "Une erreur est survenue lors de l'upload";
			setUploadError(errorMessage);
			throw error;
		}
	};

	return {
		uploadPricingFile,
		isUploading,
		uploadError,
	};
};
